var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomVigilLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 60,
    viewBox: "0 0 202 169",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.738 16.1013C81.6648 89.038 67.595 113.245 67.595 114.412C67.595 115.641 90.5567 155.586 98.0473 167.389C99.4363 169.579 102.704 169.526 104.019 167.293L109.143 158.589C113.558 151.09 136.16 112.744 159.367 73.3784C182.574 34.0124 201.758 1.33421 201.997 0.760978C202.236 0.186486 187.038 -0.131553 168.225 0.0519804L152.534 0.205933C141.056 0.318553 130.49 6.36079 124.738 16.1013Z",
    fill: "url(#paint0_linear_7947_12339)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.024 56.3932C94.3275 45.0159 86.455 31.6686 77.2617 16.1015C71.5099 6.36094 60.9441 0.318695 49.4661 0.206076L33.7754 0.0521105C14.9623 -0.131425 -0.235684 0.186614 0.00276807 0.761103C0.242497 1.33434 19.4261 34.0126 42.6327 73.3785C65.8405 112.744 88.4419 151.09 92.8571 158.59L97.981 167.293C99.2957 169.526 102.564 169.579 103.953 167.389C107.945 161.098 116.333 146.812 123.296 134.655L169.353 56.4317C162.524 67.973 149.786 75.7349 135.199 75.7347C120.597 75.7349 107.846 67.9557 101.024 56.3932Z",
    fill: "url(#paint1_linear_7947_12339)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7947_12339",
    x1: 202.643,
    y1: 167.571,
    x2: -2.34327,
    y2: 167.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7947_12339",
    x1: -49.2885,
    y1: 84.4515,
    x2: 152.057,
    y2: 86.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomVigilLogo);
export default __webpack_public_path__ + "static/media/bottomVigilLogo.1fbb81be2aaf1a8f60ac6b90f781bafa.svg";
export { ForwardRef as ReactComponent };